import React, { useContext, useEffect, useMemo, useRef, useState } from "react";

import styles from "./CardLot.module.css";

import { Button, Card, Checkbox, Form, Input } from "antd";
import { AppContext } from "../App.context";
import axios from "axios";
import {
  checkEmpty,
  getAboteOpenUtil,
  getAboutLot,
  getCurrentDateUtil,
  getCurrentDateUtilYYYY,
  getDateUtilYYYYBydate,
  pathRoutes,
} from "../service/util.service";
import { useNavigate } from "react-router-dom";
import PrivateRoute from "../menu/PrivateRoute";
import MenuTop from "../menu/MenuTop";
import MenuLett from "../menu/Menu";
import Countdown from "react-countdown";

function CardLot(props) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(true);
  const [timeDown, setTimeDown] = useState(0);
  const [lotDate, setLotDate] = useState(null);
  const [lotDateStr, setLotDateStr] = useState("");

  const currentDate = useMemo(() => {
    return getCurrentDateUtil();
  }, []);

  const timeClose = useMemo(() => {
    return props.lot.lot_time_close;
  }, []);

  const loadAboteOpen = () => {
    let res = getAboteOpenUtil(props.lot);

    setLotDateStr(res.textNext);
    setLotDate(res.lot_date);
    return res;
  };

  const checkOpen = () => {
    loadAboteOpen();
    setOpen(getAboteOpenUtil(props.lot)?.status);
  };

  const getTimeDown = useMemo(() => {
    let open = getAboteOpenUtil(props.lot);
    let time = 0;
    if (open.status) {
      time = open.time;
    }
    return (
      <Countdown
        date={Date.now() + time}
        onComplete={() => {
          console.log("check again");
          // checkOpen()
          setOpen(false);
        }}
      />
    );
  }, []);

  useEffect(() => {
    checkOpen();
  }, []);

  const onclick = () => {
    navigate(pathRoutes.main_s1 + "?lot_id=" + props.lot.lot_id);
  };

  const getCssCardBox = () => {
    if (props.lot?.lot_type == "หวยรายวัน") {
      return styles.cardLot1;
    } else if (props.lot?.lot_type == "หวยไทย") {
      return styles.cardLot2;
    } else if (props.lot?.lot_type == "หวยหุ้น") {
      return styles.cardLot3;
    } else if (props.lot?.lot_type == "หวยหุ้น VIP") {
      return styles.cardLot4;
    } else if (props.lot?.lot_type == "หวยต่างประเทศ") {
      return styles.cardLot5;
    } else if (props.lot?.lot_type == "โพยหลอก") {
      return styles.cardLot6;
    }
  };

  return (
    <Card
      // style={{ width: 240 }}
      headStyle={{ color: open ? "white" : "white", padding: "0 15px" }}
      bodyStyle={{ padding: "15px", color: "white" }}
      hoverable
      onClick={onclick}
      className={[
        getCssCardBox(),
        styles.cardLotMain,
        open ? styles.cardLotActive : styles.cardLot,
      ].join(" ")}
      title={
        <div className={styles.boxHeader} style={{ marginBottom: "8px" }}>
          <div>{props.lot.lot_name}</div>
          <div style={{ fontWeight: "bold" }}>
            {lotDate}
            <span style={{ paddingLeft: "10px" }}>{lotDateStr}</span>
          </div>
        </div>
      }
      bordered={false}
      // style={{ width: "100%" }}
    >
      {open ? (
        <>
          <div className={styles.boxHeader}>
            <div className={styles.detailCard}>
              <div>เวลาปิด</div>
              <div>
                {lotDate} {timeClose}
              </div>
            </div>
            <div className={styles.detailCard}>
              <div>สถานะ</div>
              <div>ปิดใน {getTimeDown}</div>
            </div>
          </div>
        </>
      ) : (
        <div className={styles.boxHeader}>
          <div className={styles.detailCard}>
            <div>สถานะ</div>
            <div>ปิด({timeClose})</div>
          </div>
        </div>
      )}
    </Card>
  );
}
export default CardLot;
